export default "__VITE_ASSET__b4dde728__"